// src/components/PrivateRoute.js
import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";

const PrivateRoute = ({ children, requireUserType }) => {
  const { currentUser, userType, loading } = useContext(AuthContext);
  const location = useLocation();
  
  // In preview mode, allow access to protected routes
  if (process.env.REACT_APP_PREVIEW_MODE === "true") {
    return children;
  }
  
  // While auth state (or role) is loading, render nothing to avoid flicker/misredirects
  if (loading) {
    return null;
  }

  // If not logged in, redirect to login
  if (!currentUser) {
    return <Navigate to="/login" state={{ from: location }} />;
  }
  
  // If a specific user type is required but not yet known, wait
  if (requireUserType && userType == null) {
    return null;
  }
  
  // If a specific user type is required and doesn't match, redirect to login with message
  if (requireUserType && userType !== requireUserType) {
    return <Navigate to={`/login?message=${requireUserType}-only`} state={{ from: location }} />;
  }
  
  // User is logged in and meets requirements
  return children;
};

export default PrivateRoute;

